import React from "react";
import { Box, Typography, Badge, Tooltip, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FiClipboard } from "react-icons/fi";
import {
  selectAddeparPendingCount,
  selectAddeparInventoryLoaded,
} from "../../Redux/Reducers/addeparInventorySlice";


const AddeparInventoryBadge = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const pendingCount = useSelector(selectAddeparPendingCount);
  const loaded = useSelector(selectAddeparInventoryLoaded);

  if (!loaded || pendingCount <= 0) return null;

  const itemLabel = pendingCount === 1 ? "item" : "items";
  const tooltip = `We have ${pendingCount} new ${itemLabel} in Addepar. Click to view.`;

  return (
    <Tooltip title={tooltip} arrow placement="bottom">
      <Box
        onClick={() => navigate("/addepar-inventory")}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            navigate("/addepar-inventory");
          }
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 1.5,
          py: 1,
          cursor: "pointer",
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          backgroundColor:
            theme.palette.mode === "dark" ? "#2d2d2d" : "#f5f5f5",
          outline: "none",
          "&:hover": {
            backgroundColor:
              theme.palette.mode === "dark" ? "#383838" : "#eeeeee",
          },
          "&:focus-visible": {
            boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
          },
        }}
      >
        <Badge
          badgeContent={pendingCount}
          color="error"
          max={99}
          sx={{
            "& .MuiBadge-badge": {
              fontSize: "0.65rem",
              fontWeight: 700,
              minWidth: 18,
              height: 18,
              bgcolor: "#f44336",
              color: "#fff",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              color: theme.palette.text.primary,
              lineHeight: 0,
            }}
          >
            <FiClipboard size={18} />
          </Box>
        </Badge>
        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            color: theme.palette.text.secondary,
            whiteSpace: "nowrap",
          }}
        >
          Addepar
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default AddeparInventoryBadge;
